namespace Vit.Administration {
    //@Serenity.Decorators.registerInterface()
    export interface ChangeOwnershipRow {
        UserId?: string;
    }


    @Serenity.Decorators.registerClass()
    export class ChangeOwnershipEditDialog extends Serenity.EntityDialog<ChangeOwnershipRow, any> {
        static formKey: string = "Administration.ChangeOwnership";

        constructor() {
            super();
        }

        protected getFormKey() {
            return ChangeOwnershipEditDialog.formKey;
        }

        protected getIdProperty() {
            return "Id";
        }
        public setService(value: string) {
            this.service = value;
        }
        protected getSaveOptions(callback: (response: Serenity.SaveResponse) => void): Serenity.ServiceOptions<Serenity.SaveResponse> {
            var opts = super.getSaveOptions(callback);
            opts.service = `${this.getService()}/ChangeOwnership`;
            return opts;
        }

        protected hasDeletePermission(): boolean {
            return false;
        }
    }

}
